import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Author Name', field: 'author_name'
    },
    {
      label: 'Create at', field: 'created_at'
    },
    {
      label: 'Tittle', field: 'title'
    },
    {
      label: 'Subtitle', field: 'sub_title'
    },
    {
      label: 'Category', field: 'artc_ctgr_name'
    },
    {
      label: 'Sub Category', field: 'artc_sub_ctgr_name'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/articles//status/AC'}
    useIPA.get(param).then(response => {
      const article = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...article})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/article/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        artc_sub_ctgr_id: formData.select_1,
        title: formData.text_2,
        sub_title: formData.text_3,
        content: formData.content_4,
        is_draft: formData.checkbox_5 === true ? 'Y' : 'N',
        is_mobile: formData.checkbox_6 === true ? 'Y' : 'N',
        is_highlight: formData.checkbox_7 === true ? 'Y' : 'N'
			}
      const param = { rawData: rawData, url: 'dashboard/master/article', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'article' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/article', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, article) {
    state.all = article.rows
    state.pages = article.pages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
